import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
  name: "ActivityChartComponent",
  datasets: ChartDatasets.getActivityChartDataSet(),
  labels: "months",
  loading: false,
  style:"height: 150px",
  options: ChartOptions.getActivityChartOptions()
}